import BaseService from "./base.service";

export default class ContactService extends BaseService{

   static async contact (params) {
       return new Promise((resolve, reject) => {

        this.request()
            .post('/contact/', params)
            .then(response => {
                resolve(response.data)
            })
            .catch(error =>{
                console.log(error.response)
                reject(error.response.data)
            } )
           
       })
    }
 
}